<template>
  <div class="myWrap">
    <div class="content">
      <div class="topPic">
        <van-image
            width="50px"
            height="50px"
            fit="cover"
            :src="photoSrc"
            style="border-radius:50%;border:1px solid #fff;"
        />
        <span style="margin-top:1rem;">{{ userInfo.userName }}</span>
      </div>
      <nut-row class="item-row">
        <nut-col>
          <van-cell @click="userState">
            <div slot="title">
              <div style="display: flex;align-items: center">
                <van-icon name="/static/images/yaokong.png"/>
                <span class="van-cell-text">用户状态</span>
              </div>
              <span class="cell-right"> <van-icon name="arrow"/> </span>
            </div>
          </van-cell>
        </nut-col>
      </nut-row>
      <nut-row class="item-row">
        <nut-col>
          <van-cell>
            <div slot="title">
              <div style="display: flex;align-items: center">
                <van-icon name="/static/images/dizhi.png"/>
                <span class="van-cell-text">客户地址</span>
              </div>
              <span class="cell-right">{{ userInfo.addr ? userInfo.addr : '无' }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div slot="title">
              <div style="display: flex;align-items: center">
                <van-icon name="/static/images/qixian.png"/>
                <span class="van-cell-text">账户期限</span>
              </div>
              <span class="cell-right">{{ userInfo.validTime ? userInfo.validTime : '无' }}</span>
            </div>
          </van-cell>
        </nut-col>
      </nut-row>
      <nut-row class="item-row">
        <nut-col>
          <van-cell @click="toTelecontrol">
            <div slot="title">
              <div style="display: flex;align-items: center">
                <van-icon name="/static/images/yaokong.png"/>
                <span class="van-cell-text">设备遥控</span>
              </div>
              <span class="cell-right"> <van-icon name="arrow"/> </span>
            </div>
          </van-cell>
        </nut-col>
      </nut-row>
      <nut-row class="item-row">
        <nut-col>
          <van-cell @click="wipecache">
            <div slot="title">
              <div style="display: flex;align-items: center">
                <van-icon name="/static/images/tuichu.png"/>
                <span class="van-cell-text">清空缓存</span>
              </div>
              <span class="cell-right"> <van-icon name="arrow"/> </span>
            </div>
          </van-cell>
        </nut-col>
      </nut-row>
      <nut-row class="item-row">
        <nut-col>
          <van-cell @click="logout">
            <div slot="title">
              <div style="display: flex;align-items: center">
                <van-icon name="/static/images/tuichu.png"/>
                <span class="van-cell-text">退出</span>
              </div>
              <span class="cell-right"> <van-icon name="arrow"/> </span>
            </div>
          </van-cell>
        </nut-col>
      </nut-row>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {Dialog} from 'vant'
import wx from 'weixin-js-sdk'

export default {
  name: 'My',
  data() {
    return {
      userInfo: {
        userName: 'NONE',
        usedAuthNum: 0,
        authorizeNum: 0,
        usedSpace: 0,
        totalSpace: 0,
        addr: '',
        validTime: '',
      },
      photoSrc: '',
    }
  },
  mounted() {
    this.getUserInfo()
    /*this.$ajax('/etv/getWeixinAccessToken.json').then(res => {
      if (res.data.code === 0) {
        wx.config({
          debug: false,//是否开启调试
           appId: 'wxf4ecc1546a053d74',//小程序appid
          // appId: 'wxa12dcf325e893ef5',//ys
          //  appId: 'wx3a88cb95f63e6557',//皇尊年华
          timestamp: res.data.data.timestamp,//时间搓，单位秒
          nonceStr: res.data.data.nonceStr,//随机字符串
          signature: res.data.data.signature,//签名md5
          jsApiList: ['scanQRCode'],
        })
      } else {
        Toast(res.data.msg)
      }
    })*/

  },
  methods: {
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
    getUserInfo() {
      let _this = this
      this.$ajax.get('/etv/selectPersonerInfo.json').then(res => {
        if (res.data.data.level == '1') {
          _this.photoSrc = '/static/images/level1.png'
        } else if (res.data.data.level == '2') {
          _this.photoSrc = '/static/images/level2.png'
        } else if (res.data.data.level == '3') {
          _this.photoSrc = '/static/images/level3.png'
        } else if (res.data.data.level == '4') {
          _this.photoSrc = '/static/images/level4.png'
        }

        let totalSpace = res.data.data.materialRam * 1
        let usedSpace = res.data.data.usedMtNum * 1
        totalSpace >= 1024 ? totalSpace = (totalSpace / 1024).toFixed(1) + 'G' : totalSpace = totalSpace + 'M'
        usedSpace >= 1024 ? usedSpace = (usedSpace / 1024).toFixed(1) + 'G' : usedSpace = usedSpace + 'M'

        _this.userInfo.userName = res.data.data.userName
        _this.userInfo.usedAuthNum = res.data.data.usedAuthNum
        _this.userInfo.authorizeNum = res.data.data.authorizeNum
        _this.userInfo.usedSpace = usedSpace
        _this.userInfo.totalSpace = totalSpace
        _this.userInfo.validTime = res.data.data.validTime
        _this.userInfo.addr = res.data.data.addr

      })
    },
    toTelecontrol() {
      this.changeTopTitle('远程遥控')
      this.changeTopIconStatus(true)
      this.setParentPage('my')
      this.$router.push({path: '/telecontrol'})
    },
    userState() {
      this.$router.push({path: '/index'})
    },
    wipecache() {
      window.location.reload()
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    },
    logout() {
      Dialog.confirm({
        title: '退出登陆'
        , message: '是否确定退出登录？',
      }).then(() => {
        this.$ajax.post('/etv/logout.json').then(() => {
          this.$router.push('/login')
        })
      }).catch(() => {
      })

    },
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.myWrap {
  height: calc(100% - 70px) !important;
  overflow-y: auto;
  overflow-y: auto;

  .content {
    height: 100%;
    padding-bottom: 30px;

    .topPic {
      height: 130px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #1B89FA;
      color: #fff;

      .van-image {
        border-radius: 50%;
        overflow: hidden;
      }
    }

    .dataWrap {
      background: #1B89FA;
      color: #fff;
      height: 4rem;
      border-top: 1px solid #fff;

      .nut-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        overflow: hidden;

        &:first-child {
          border-right: 1px solid #fff;
        }

        span {
          width: 100%;
          word-wrap: break-word;
          text-align: center;
          max-height: 40px;
          overflow: hidden;
        }
      }
    }

    .item-row {
      margin: 10px 0;
      background: #fff;

      .cell-right {
        float: right;
      }

      .van-icon {
        margin: 2px 4px 0 0;
      }

    }

    .van-cell__title {
      & > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

    }
  }

  .bigBtn {
    padding: 0 20px;

    .van-button--large {
      border-radius: 40px;
    }
  }
}
</style>
